/**
 * 消息提醒管理
 * @author
 */
import api from '@/services/api'
import {METHOD, request} from '@/utils/request'

export const dataApi = {
    async getFormDetail(keyId) {
        return request(api.comm.ECTASKPROMPT + "/selectOne?id=" + keyId, METHOD.GET);
    },
    async changeHasRead(keyId) {
        return request(api.comm.ECTASKPROMPT + "/changeHasRead?id=" + keyId, METHOD.GET);
    },
    async homePageData(num) {
        return request(api.comm.ECTASKPROMPT + "/homePageData?num=" + num, METHOD.GET);
    },
    async homePageNum() {
        return request(api.comm.ECTASKPROMPT + "/homePageNum", METHOD.GET);
    },
    async saveFormDetail(result) {
        return request(api.comm.ECTASKPROMPT, METHOD.POST, result);
    },
}


export default {dataApi}